import React from 'react'

import i18n from 'live/services/i18n'

import { RowDiv } from './styles'

export interface ILivePaginationProps {
    type: 'live'
    totalItems: number
    showingItems: number
    perPage:number
    label?: string
    /**
     * onPerPageChange will return the new max itens per page on list
     */
    onPerPageChange?: () => void
}

export const LivePagination: React.FC<ILivePaginationProps> = ({
    showingItems,
    totalItems,
    onPerPageChange,
    label,
    perPage
}) => {
    const moreItems = (): number => {
        const showMore = totalItems - showingItems
        if (showMore > perPage) {
            return perPage
        } else {
            return showMore
        }
    }

    return (
        <RowDiv>
            <div className="row-div-label">
                {i18n('Showing')} {showingItems > totalItems ? totalItems : showingItems} {i18n('of')} {totalItems}{' '}
                {i18n(label).toLowerCase()}
            </div>
            {showingItems < totalItems && (
                <button className="btn btn-primary" onClick={onPerPageChange}>
                    <i className="fas fa-arrow-circle-down"></i> {i18n('Load more')} {moreItems()}
                </button>
            )}
        </RowDiv>
    )
}
